import { Button, FormInstance, Row } from "antd";
import { useCallback } from "react";

type ButtonGroupProps = {
  form: FormInstance;
  close: () => void;
  onSchedule: (values: any) => void;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ButtonGroup = ({
  form,
  close,
  onSchedule,
  setOpen,
}: ButtonGroupProps) => {
  const onScheduleClick = useCallback(async () => {
    try {
      const values = await form.validateFields();

      setOpen(false);
      onSchedule(values);
    } catch {}
  }, [setOpen, onSchedule, form]);

  return (
    <Row className="justify-end align-center pt-6 pb-2">
      <Button type="primary" shape="round" onClick={onScheduleClick}>
        Schedule
      </Button>
      <Button shape="round" className="ml-2" onClick={close}>
        Cancel
      </Button>
    </Row>
  );
};
